define('plugin/static-page/view/PageView',['require','lib/view/LayoutView','Config'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	var Config = require('Config');
	
	/**
	 * Static page view
	 * 
	 * @class PageView
	 */
	return LayoutView.extend({

		template: '#static_page',

		modelEvents: {
			'change': 'render'
		},
		ui: {
		},

		serializeData: function () {
			var result = LayoutView.prototype.serializeData.apply(this);

			return jQuery.extend(result, {
				'show_title' : parseInt(this.model.get('show_title'))
			});
		},

		onDomRefresh: function () {
			this.onShowPage();
		},

		onShowPage: function () {
			Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
				'page': 'static-page',
			});
		}

	});
	
});
